import { render, staticRenderFns } from "./chairman.vue?vue&type=template&id=1333ae8d&scoped=true"
import script from "./chairman.vue?vue&type=script&lang=js"
export * from "./chairman.vue?vue&type=script&lang=js"
import style0 from "./chairman.vue?vue&type=style&index=0&id=1333ae8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333ae8d",
  null
  
)

export default component.exports